import Login from "./features/auth/pages/Login";
import UserIndex from './features/users/pages/List';
import UserCreate from './features/users/pages/Create';
import UserShow from './features/users/pages/Show';
import UserUpdate from "./features/users/pages/Update";
import ProductCategoryIndex from "./features/productCategories/pages/List";
import ProductCategoriesCreate from "./features/productCategories/pages/Create";
import ProductCategoriesShow from "./features/productCategories/pages/Show";
import ProductCategoriesUpdate from "./features/productCategories/pages/Update";
import Products from "./features/products/pages/List";
import ProductsCreate from "./features/products/pages/Create";
import ProductsUpdate from "./features/products/pages/Update";
import ProductShow from "./features/products/pages/Show";
import EquipmentModelsIndex from "./features/equipmentModels/pages/List";
import EquipmentModelsCreate from "./features/equipmentModels/pages/Create";
import EquipmentModelsShow from "./features/equipmentModels/pages/Show";
import EquipmentModelsUpdate from "./features/equipmentModels/pages/Update";
import GeneralDocumentsIndex from "./features/generalDocuments/pages/List";
import GeneralDocumentsCreate from "./features/generalDocuments/pages/Create";
import GeneralDocumentsUpdate from "./features/generalDocuments/pages/Update";
import GeneralDocumentsShow from "./features/generalDocuments/pages/Show";
import FeeTemplatesIndex from "./features/feeTemplates/pages/List";
import FeeTemplatesCreate from "./features/feeTemplates/pages/Create";
import FeeTemplatesShow from "./features/feeTemplates/pages/Show";
import FeeTemplatesUpdate from "./features/feeTemplates/pages/Update";
import PrivateClientsFunnelList from "./features/privateCompanyLeadsFunnel/pages/List";
import PrivateClientsFunnelUpdate from "./features/privateCompanyLeadsFunnel/pages/Update";
import PrivateClientsFunnelContactsUpdate from "./features/privateCompanyLeadsFunnel/pages/Contacts/Update";
import PrivateClientsFunnelContractsUpdate from "./features/privateCompanyLeadsFunnel/pages/Contracts/Update";
import ClientRoles from "./features/clientRoles/pages/List";
import ClientRolesCreate from "./features/clientRoles/pages/Create";
import ClientRolesShow from "./features/clientRoles/pages/Show";
import ClientRolesUpdate from "./features/clientRoles/pages/Update";
import EstablishmentRoles from "./features/establishmentRoles/pages/List";
import EstablishmentRolesCreate from "./features/establishmentRoles/pages/Create";
import EstablishmentRolesShow from "./features/establishmentRoles/pages/Show";
import EstablishmentRolesUpdate from "./features/establishmentRoles/pages/Update";
import HolidaysList from "./features/holidays/pages/List"
import HolidaysCreate from "./features/holidays/pages/Create"
import HolidaysShow from "./features/holidays/pages/Show"
import HolidaysUpdate from "./features/holidays/pages/Update"
import Permissions from "./features/permissions/pages/List";
import PermissionsCreate from "./features/permissions/pages/Create";
import PermissionShow from "./features/permissions/pages/Show";
import PermissionUpdate from "./features/permissions/pages/Update";
import TcardRoles from "./features/tcardRoles/pages/List";
import TcardRolesCreate from "./features/tcardRoles/pages/Create";
import TcardRolesShow from "./features/tcardRoles/pages/Show";
import TcardRolesUpdate from "./features/tcardRoles/pages/Update";
import UserProfileShow from "./features/userProfile/pages/Show";
import UserProfileActionsHistoryShow from "./features/userProfile/pages/ActionsHistoryShow";
import Companies from "./features/companies/pages/List";
import CompanyShow from "./features/privateCompanies/pages/Show";
import CompanyUpdate from "./features/privateCompanies/pages/Update";
import CompanyContractShow from "./features/privateCompanies/pages/CompanyContracts/Show";
import CompanyUserCreate from "./features/privateCompanies/pages/CompanyUsers/Create";
import CompanyUserShow from "./features/privateCompanies/pages/CompanyUsers/Show";
import CompanyUserActionsHistoryShow from "./features/privateCompanies/pages/CompanyUsers/ActionsHistoryShow";
import CompanyUserUpdate from "./features/privateCompanies/pages/CompanyUsers/Update";
import CompanyBranchesCreate from "./features/privateCompanies/pages/CompanyBranches/Create";
import CompanyBranchesShow from "./features/privateCompanies/pages/CompanyBranches/Show";
import CompanyBranchesUpdate from "./features/privateCompanies/pages/CompanyBranches/Update";
import CompanyEquipmentsCreate from "./features/privateCompanies/pages/CompanyEquipments/Create";
import CompanyEquipmentsShow from "./features/privateCompanies/pages/CompanyEquipments/Show";
import CompanyEquipmentsChangeHistoryShow from "./features/privateCompanies/pages/CompanyEquipments/ChangeHistoryShow";
import CompanyEquipmentsUpdate from "./features/privateCompanies/pages/CompanyEquipments/Update";
import CompanyGovernmentAllocationShow from "./features/privateCompanies/pages/CompanyGovernmentAllocations/Show";
import CompanyGovernmentAllocationUpdate from "./features/privateCompanies/pages/CompanyGovernmentAllocations/Update";
import CompanyPriceSurveyCreate from "./features/privateCompanies/pages/CompanyPriceSurvey/Create";
import CompanyPriceSurveyShow from "./features/privateCompanies/pages/CompanyPriceSurvey/Show";
import CompanyPriceSurveyUpdate from "./features/privateCompanies/pages/CompanyPriceSurvey/Update";
import Consumption from "./features/consumption/pages/Create";
import CardCurrentLimitsShow from "./features/cardCurrentLimits/pages/Show";
import Refund from "./features/refund/pages/Create";
import EstablishmentFunnelList from "./features/establishmentLeadsFunnel/pages/List";
import EstablishmentFunnelUpdate from "./features/establishmentLeadsFunnel/pages/Update";
import EstablishmentFunnelContactsUpdate from "./features/establishmentLeadsFunnel/pages/Contacts/Update";
import EstablishmentFunnelContractsUpdate from "./features/establishmentLeadsFunnel/pages/Contracts/Update";
import EstablishmentCompanyList from "./features/establishments/pages/List";
import EstablishmentCompanyShow from "./features/establishments/pages/Show";
import EstablishmentContractShow from "./features/establishments/pages/EstablishmentContracts/Show";
import EstablishmentUserCreate from "./features/establishments/pages/EstablishmentUsers/Create";
import EstablishmentUserShow from "./features/establishments/pages/EstablishmentUsers/Show";
import EstablishmentUserActionsHistoryShow from "./features/establishments/pages/EstablishmentUsers/ActionsHistoryShow";
import EstablishmentUserUpdate from "./features/establishments/pages/EstablishmentUsers/Update";
import PublicCompanyFunnelList from "./features/publicCompanyLeadsFunnel/pages/List";
import PublicCompanyFunnelUpdate from "./features/publicCompanyLeadsFunnel/pages/Update";
import PublicFunnelContactsUpdate from "./features/publicCompanyLeadsFunnel/pages/Contacts/Update";
import PublicFunnelContractsUpdate from "./features/publicCompanyLeadsFunnel/pages/Contracts/Update";
import Building from "./common/Layout/building";
import PosList from "./features/pos/pages/List";
import PosQrCode from "./features/pos/pages/QrCode";
import PosShow from "./features/pos/pages/Show";
import UserActionsHistoryShow from "./features/users/pages/ActionsHistoryShow";
import ExternalSupportList from "./features/support/external/pages/List";
import ExternalSupportShow from "./features/support/external/pages/Show";
import ExternalSupportCreate from "./features/support/external/pages/Create";
import ResetPassword from "./features/auth/pages/ResetPassword";
import AllCardsList from "./features/cards/pages/AllCards/List";
import PendingCardsList from "./features/cards/pages/PendingCards/List";
import PendingCardsShow from "./features/cards/pages/PendingCards/Show";
import AnpReportsList from "./features/anpReports/pages/List";
import AnpReportsShow from "./features/anpReports/pages/Show";
import AnpHistoricalReportsList from "./features/anpHistoricalReports/pages/List";
import AnpHistoricalReportsShow from "./features/anpHistoricalReports/pages/Show";
import TrackerIntegrationsCreate from './features/privateCompanies/pages/CompanyTrackerIntegration/Create'
import TrackerIntegrationsShow from './features/privateCompanies/pages/CompanyTrackerIntegration/Show'
import TrackerIntegrationsUpdate from './features/privateCompanies/pages/CompanyTrackerIntegration/Update'
import EventsWithFiscalDocumentRequirementList from "./features/billing/pages/EventsWithFiscalDocumentRequirement/List";
import EventsWithFiscalDocumentRequirementShow from "./features/billing/pages/EventsWithFiscalDocumentRequirement/Show";
import BillingFiscalDocumentGroupsList from "./features/billing/pages/FiscalDocumentGroups/List";
import BillingFiscalDocumentGroupsShow from "./features/billing/pages/FiscalDocumentGroups/Show";
import ClientBillsList from "./features/clientBills/pages/List";
import EstablishmentBillsList from "./features/establishmentBills/pages/List";
import ClientBillShow from "./features/clientBills/pages/Show";
import EstablishmentBillShow from "./features/establishmentBills/pages/Show";
import PrivateCompanyBillShow from "./features/privateCompanies/pages/Bills/Show";
import EstablishmentCompanyBillShow from "./features/establishments/components/EstablishmentBillShow";
import DashboardShow from "./features/dashboard/pages/Show";
import ReportsPermittedReports from "./features/reports/pages/PermittedReports";
import ReportsSubmit from "./features/reports/pages/Submit";
import PrinterMachineList from "./features/printerMachines/pages/List";
import PrinterMachineShow from "./features/printerMachines/pages/Show";
import EstablishmentCompanyUpdate from "./features/establishments/pages/Update";
import GovernmentAllocationsEntriesNotCompletedList from "./features/governmentAllocations/pages/NotCompleted";
import SupplyAuthorizationsList from "./features/supplyAuthorizations/pages/List";
import SupplyAuthorizationsShow from "./features/supplyAuthorizations/pages/Show";
import PaymentAdvanceList from "./features/paymentAdvances/pages/List";
import PaymentAdvanceShow from "./features/paymentAdvances/pages/Show";
import PaymentAdvanceCreate from "./features/paymentAdvances/pages/Create";
import NegotiationsList from "./features/negotiations/pages/List";
import NegotiationsShow from "./features/negotiations/pages/Show";
import EstablishmentBillPaymentAdvancesList from "./features/establishments/pages/Tabs/Bills/PaymentAdvances";
import EquipmentCategoriesList from "./features/equipmentCategories/pages/List";
import EquipmentCategoriesShow from "@/features/equipmentCategories/pages/Show";
import EquipmentCategoriesUpdate from "@/features/equipmentCategories/pages/Update";
import MissionsList from "./features/missions/pages/List";
import MissionsCreate from "./features/missions/pages/Create";
import MissionsEdit from "./features/missions/pages/Edit";
import MissionsShow from "./features/missions/pages/Show";
import BankInstitutionsList from "./features/bankInstitutions/pages/List";
import BankInstitutionsCreate from "./features/bankInstitutions/pages/Create";
import BankInstitutionsShow from "./features/bankInstitutions/pages/Show";
import BankInstitutionsUpdate from "./features/bankInstitutions/pages/Update";
import OAuthGoogle from './features/auth/pages/OAuth/Google';
import AccessDenied from "./features/auth/pages/AccessDenied";
import RecipientMessagesList from "./features/recipientMessages/pages/List";
import NotificationsConfigurationsShow from "./features/notifications/pages/Configurations/Show";
import { NotFoundPage } from "./common/components/NotFoundErrorMessage";
import TefConfigurationShow from "./features/establishments/pages/Tabs/TefConfiguration/Show";
import LogList from "./features/logs/pages/List";
import LogShow from "./features/logs/pages/Show";
import InternalSupportList from "./features/support/internal/pages/List";
import InternalSupportCreate from "./features/support/internal/pages/Create";
import InternalSupportShow from "./features/support/internal/pages/Show";
import InternalSupportUpdate from "./features/support/internal/pages/Update";
import BillingDynamicGroupablesUpdate from "./features/privateCompanies/pages/BillDynamicGroupables/Update";
import BankingDepositsCreate from "./features/privateCompanies/pages/BankingDeposits/Create";
import BankingDepositsShow from "./features/privateCompanies/pages/BankingDeposits/Show";
import ClientPermissionsList from "./features/clientPermissions/pages/List";
import ClientPermissionsCreate from "./features/clientPermissions/pages/Create";
import ClientPermissionsShow from "./features/clientPermissions/pages/Show";
import ClientPermissionsUpdate from "./features/clientPermissions/pages/Update";
import EstablishmentPermissionsList from "./features/establishmentPermissions/pages/List";
import EstablishmentPermissionsCreate from "./features/establishmentPermissions/pages/Create";
import EstablishmentPermissionsShow from "./features/establishmentPermissions/pages/Show";
import EstablishmentPermissionsUpdate from "./features/establishmentPermissions/pages/Update";
import EstablishmentRequiredDocumentsList from "./features/maintenance/establishmentRequiredDocuments/pages/List";
import EstablishmentRequiredDocumentsCreate from "./features/maintenance/establishmentRequiredDocuments/pages/Create";
import EstablishmentRequiredDocumentsShow from "./features/maintenance/establishmentRequiredDocuments/pages/Show";
import EstablishmentRequiredDocumentsUpdate from "./features/maintenance/establishmentRequiredDocuments/pages/Update";
import EstablishmentInfrastructuresList from "./features/maintenance/establishmentInfrastructures/pages/List";
import EstablishmentInfrastructuresCreate from "./features/maintenance/establishmentInfrastructures/pages/Create";
import EstablishmentInfrastructuresShow from "./features/maintenance/establishmentInfrastructures/pages/Show";
import EstablishmentInfrastructuresUpdate from "./features/maintenance/establishmentInfrastructures/pages/Update";
import EstablishmentTechnicalProfessionalsList from "./features/maintenance/establishmentTechnicalProfessionals/pages/List";
import EstablishmentTechnicalProfessionalsCreate from "./features/maintenance/establishmentTechnicalProfessionals/pages/Create";
import EstablishmentTechnicalProfessionalsShow from "./features/maintenance/establishmentTechnicalProfessionals/pages/Show";
import EstablishmentTechnicalProfessionalsUpdate from "./features/maintenance/establishmentTechnicalProfessionals/pages/Update";
import MaintenanceObjectiveMaintenance from "./features/maintenance/objectiveMaintenance/pages";
import MaintenanceObjectiveSystemsCreate from "./features/maintenance/objectiveMaintenance/objectiveSystems/pages/Create";
import MaintenanceObjectiveSystemsShow from "./features/maintenance/objectiveMaintenance/objectiveSystems/pages/Show";
import MaintenanceObjectiveSystemsUpdate from "./features/maintenance/objectiveMaintenance/objectiveSystems/pages/Update";
import MaintenanceObjectivePartsCreate from "./features/maintenance/objectiveMaintenance/objectiveParts/pages/Create";
import MaintenanceObjectivePartsShow from "./features/maintenance/objectiveMaintenance/objectiveParts/pages/Show";
import MaintenanceObjectivePartsUpdate from "./features/maintenance/objectiveMaintenance/objectiveParts/pages/Update";
import MaintenanceObjectiveActionsCreate from "./features/maintenance/objectiveMaintenance/objectiveActions/pages/Create";
import MaintenanceObjectiveActionsShow from "./features/maintenance/objectiveMaintenance/objectiveActions/pages/Show";
import MaintenanceObjectiveActionsUpdate from "./features/maintenance/objectiveMaintenance/objectiveActions/pages/Update";
import GovernmentAllocationBillShow from "./features/privateCompanies/pages/CompanyGovernmentAllocations/Show/GovernmentAllocationBills";
import RewardItems from "./features/rewardItems/pages/List";
import RewardItemsCreate from "./features/rewardItems/pages/Create";
import RewardItemsShow from "./features/rewardItems/pages/Show";
import RewardItemsUpdate from "./features/rewardItems/pages/Update";
import TmaisBadgesList from "./features/tmaisBadges/pages/List";
import TmaisBadgesCreate from "./features/tmaisBadges/pages/Create";
import TmaisBadgesShow from "./features/tmaisBadges/pages/Show";
import TmaisBadgesUpdate from "./features/tmaisBadges/pages/Edit";
import MaintenanceScrapRulesList from "./features/privateCompanies/pages/MaintenanceScrapRules/List";
import MaintenanceScrapRulesCreate from "./features/privateCompanies/pages/MaintenanceScrapRules/Create";
import MaintenanceScrapRulesShow from "./features/privateCompanies/pages/MaintenanceScrapRules/Show";
import MaintenanceScrapRulesUpdate from "./features/privateCompanies/pages/MaintenanceScrapRules/Update";
import TmaisBannersList from "./features/tmaisBanners/pages/List";
import TmaisBannersCreate from "./features/tmaisBanners/pages/Create";
import TmaisBannerShow from './features/tmaisBanners/pages/Show';
import TmaisBannerUpdate from './features/tmaisBanners/pages/Update';
import MaintenanceSolicitationsList from "./features/privateCompanies/pages/MaintenanceSolicitations/List";
import MaintenanceSolicitationsCreate from "./features/privateCompanies/pages/MaintenanceSolicitations/Create";
import MaintenanceSolicitationsShow from "./features/privateCompanies/pages/MaintenanceSolicitations/Show";
import MaintenanceSolicitationsUpdate from "./features/privateCompanies/pages/MaintenanceSolicitations/Update";
import TmaisUsers from "./features/tmaisUsers/pages/List";
import TmaisUsersShow from "./features/tmaisUsers/pages/Show";
import UsersUpdate from "./features/tmaisUsers/tabs/users/Update";
import CompanyMaintenanceWorkflowsList from "./features/privateCompanies/pages/Maintenance/Workflows/List";
import CompanyMaintenanceWorkflowsCreate from "./features/privateCompanies/pages/Maintenance/Workflows/Create";
import CompanyMaintenanceWorkflowsShow from "./features/privateCompanies/pages/Maintenance/Workflows/Show";
import CompanyMaintenanceWorkflowsForwardingsCreate from "./features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/pages/Create";
import TmaisRafflesList from "./features/tmaisRaffles/pages/List";
import TmaisRafflesShow from "./features/tmaisRaffles/pages/Show";
import TmaisRafflesCreate from "./features/tmaisRaffles/pages/Create";
import TmaisRafflesUpdate from "./features/tmaisRaffles/pages/Update";

export const publicRoutes = [
  { path: '/login', comp: Login },
  { path: '/reset-password', comp: ResetPassword },
  { path: '/oauth/google', comp: OAuthGoogle },
  { path: '/access-denied', comp: AccessDenied },
];

export const privateRoutes = [
  // not found
  { path: '*', comp: NotFoundPage },

  // dashboard
  { path: '/', comp: DashboardShow },

  // printer machines
  { path: '/printer-machines', comp: PrinterMachineList },
  { path: '/printer-machines/:id', comp: PrinterMachineShow },

  // companies
  { path: '/companies', comp: Companies },
  { path: '/companies/:id/edit/*', comp: CompanyUpdate },
  { path: '/companies/:id/*', comp: CompanyShow },
  { path: '/companies/:id/bills/:billId/*', comp: PrivateCompanyBillShow },
  { path: '/companies/:companyId/contracts/:id', comp: CompanyContractShow },
  { path: '/companies/:companyId/branches/create', comp: CompanyBranchesCreate },
  { path: '/companies/:companyId/branches/:id/*', comp: CompanyBranchesShow },
  { path: '/companies/:companyId/branches/:id/edit', comp: CompanyBranchesUpdate },
  { path: '/companies/:id/equipments/create', comp: CompanyEquipmentsCreate },
  { path: '/companies/:companyId/equipments/:id/edit', comp: CompanyEquipmentsUpdate },
  { path: '/companies/:companyId/equipments/:id/changeHistory/:requestId', comp: CompanyEquipmentsChangeHistoryShow },
  { path: '/companies/:companyId/equipments/:id/*', comp: CompanyEquipmentsShow },
  { path: '/companies/:id/users/create', comp: CompanyUserCreate },
  { path: '/companies/:companyId/users/:id/edit/*', comp: CompanyUserUpdate },
  { path: '/companies/:companyId/users/:id/actionsHistory/:requestId', comp: CompanyUserActionsHistoryShow },
  { path: '/companies/:companyId/users/:id/*', comp: CompanyUserShow },
  { path: '/companies/:id/tracker-integrations/create', comp: TrackerIntegrationsCreate },
  { path: '/companies/:companyId/tracker-integrations/:id', comp: TrackerIntegrationsShow },
  { path: '/companies/:companyId/tracker-integrations/:id/edit', comp: TrackerIntegrationsUpdate },
  { path: '/companies/:companyId/users/:id/actionHistory', comp: CompanyUserShow },
  { path: '/companies/:companyId/government-allocations/:id/edit', comp: CompanyGovernmentAllocationUpdate },
  { path: '/companies/:companyId/government-allocations/:id/*', comp: CompanyGovernmentAllocationShow },
  { path: '/companies/:companyId/government-allocations/:governmentAllocationId/bills/:billId/*', comp: GovernmentAllocationBillShow },
  { path: '/companies/:id/price-survey/create', comp: CompanyPriceSurveyCreate },
  { path: '/companies/:companyId/price-survey/:id', comp: CompanyPriceSurveyShow },
  { path: '/companies/:companyId/price-survey/:id/edit', comp: CompanyPriceSurveyUpdate },
  { path: '/companies/:id/politics/billing-dynamic-groupables', comp: BillingDynamicGroupablesUpdate },
  { path: '/companies/:id/banking-deposits/create', comp: BankingDepositsCreate },
  { path: '/companies/:companyId/banking-deposits/:id', comp: BankingDepositsShow },
  { path: '/companies/:companyId/maintenance/scrap-rules', comp: MaintenanceScrapRulesList },
  { path: '/companies/:companyId/maintenance/scrap-rules/create', comp: MaintenanceScrapRulesCreate },
  { path: '/companies/:companyId/maintenance/scrap-rules/:id', comp: MaintenanceScrapRulesShow },
  { path: '/companies/:companyId/maintenance/scrap-rules/:id/edit', comp: MaintenanceScrapRulesUpdate },
  { path: '/companies/:id/maintenance/solicitations', comp: MaintenanceSolicitationsList },
  { path: '/companies/:id/maintenance/solicitations/create', comp: MaintenanceSolicitationsCreate },
  { path: '/companies/:companyId/maintenance/solicitations/:id', comp: MaintenanceSolicitationsShow },
  { path: '/companies/:companyId/maintenance/solicitations/:id/edit', comp: MaintenanceSolicitationsUpdate },
  { path: '/companies/:companyId/maintenance/workflows', comp: CompanyMaintenanceWorkflowsList },
  { path: '/companies/:companyId/maintenance/workflows/create', comp: CompanyMaintenanceWorkflowsCreate },
  { path: '/companies/:companyId/maintenance/workflows/:id/*', comp: CompanyMaintenanceWorkflowsShow },
  { path: '/companies/:companyId/maintenance/workflows/:workflowId/forwardings/create', comp: CompanyMaintenanceWorkflowsForwardingsCreate },
  { path: '/companies/:companyId/maintenance/workflows/:workflowId/forwardings/create/:directiveEntryType', comp: CompanyMaintenanceWorkflowsForwardingsCreate },

  // establishments
  { path: '/establishments', comp: EstablishmentCompanyList },
  { path: '/establishments/:id/edit', comp: EstablishmentCompanyUpdate },
  { path: '/establishments/:id/*', comp: EstablishmentCompanyShow },
  { path: '/establishments/:id/bills/:billId/*', comp: EstablishmentCompanyBillShow },
  { path: '/establishments/:establishmentId/contracts/:id', comp: EstablishmentContractShow },
  { path: '/establishments/:id/users/create', comp: EstablishmentUserCreate },
  { path: '/establishments/:establishmentId/users/:id/edit', comp: EstablishmentUserUpdate },
  { path: '/establishments/:establishmentId/users/:id/actionsHistory/:requestId', comp: EstablishmentUserActionsHistoryShow },
  { path: '/establishments/:establishmentId/bills/payment-advances', comp: EstablishmentBillPaymentAdvancesList },
  { path: '/establishments/:establishmentId/users/:id/*', comp: EstablishmentUserShow },
  { path: '/establishments/:establishmentId/tef-configurations/:tefProvider/*', comp: TefConfigurationShow },

  // fee templates
  { path: '/fee-templates', comp: FeeTemplatesIndex },
  { path: '/fee-templates/create', comp: FeeTemplatesCreate },
  { path: '/fee-templates/:id', comp: FeeTemplatesShow },
  { path: '/fee-templates/:id/edit', comp: FeeTemplatesUpdate },

  // anp reports
  { path: '/anp-reports', comp: AnpReportsList },
  { path: '/anp-reports/:id/*', comp: AnpReportsShow },
  { path: '/anp-historical-reports', comp: AnpHistoricalReportsList },
  { path: '/anp-historical-reports/:id/*', comp: AnpHistoricalReportsShow },

  // recipient messages
  { path: '/recipient-messages/*', comp: RecipientMessagesList },

  // bank institutions
  { path: '/bank-institutions', comp: BankInstitutionsList },
  { path: '/bank-institutions/create', comp: BankInstitutionsCreate },
  { path: '/bank-institutions/:id', comp: BankInstitutionsShow },
  { path: '/bank-institutions/:id/edit', comp: BankInstitutionsUpdate },

  // equipment categories
  { path: '/equipment-categories', comp: EquipmentCategoriesList },
  { path: '/equipment-categories/:id', comp: EquipmentCategoriesShow },
  { path: '/equipment-categories/:id/edit', comp: EquipmentCategoriesUpdate },

  // products
  { path: '/products', comp: Products },
  { path: '/products/create', comp: ProductsCreate },
  { path: '/products/:id', comp: ProductShow },
  { path: '/products/:id/edit', comp: ProductsUpdate },

  // missions
  { path: '/tmais-missions', comp: MissionsList },
  { path: '/tmais-missions/new', comp: MissionsCreate },
  { path: '/tmais-missions/:id', comp: MissionsShow },
  { path: '/tmais-missions/:id/edit', comp: MissionsEdit },

  // product categories
  { path: '/product-categories', comp: ProductCategoryIndex },
  { path: '/product-categories/create', comp: ProductCategoriesCreate },
  { path: '/product-categories/:id', comp: ProductCategoriesShow },
  { path: '/product-categories/:id/edit', comp: ProductCategoriesUpdate },

  // general documents
  { path: '/general-documents', comp: GeneralDocumentsIndex },
  { path: '/general-documents/create', comp: GeneralDocumentsCreate },
  { path: '/general-documents/:id', comp: GeneralDocumentsShow },
  { path: '/general-documents/:id/edit', comp: GeneralDocumentsUpdate },

  // equipment models
  { path: '/equipment-models', comp: EquipmentModelsIndex },
  { path: '/equipment-models/create', comp: EquipmentModelsCreate },
  { path: '/equipment-models/:id', comp: EquipmentModelsShow },
  { path: '/equipment-models/:id/edit', comp: EquipmentModelsUpdate },

  // client roles
  { path: '/client-roles', comp: ClientRoles },
  { path: '/client-roles/create', comp: ClientRolesCreate },
  { path: '/client-roles/:id', comp: ClientRolesShow },
  { path: '/client-roles/:id/edit', comp: ClientRolesUpdate },

  // client permissions
  { path: '/client-permissions', comp: ClientPermissionsList },
  { path: '/client-permissions/create', comp: ClientPermissionsCreate },
  { path: '/client-permissions/:id', comp: ClientPermissionsShow },
  { path: '/client-permissions/:id/edit', comp: ClientPermissionsUpdate },

  // establishment roles
  { path: '/establishment-roles', comp: EstablishmentRoles },
  { path: '/establishment-roles/create', comp: EstablishmentRolesCreate },
  { path: '/establishment-roles/:id', comp: EstablishmentRolesShow },
  { path: '/establishment-roles/:id/edit', comp: EstablishmentRolesUpdate },

  // holidays
  { path: '/holidays', comp: HolidaysList },
  { path: '/holidays/create', comp: HolidaysCreate },
  { path: '/holidays/:id', comp: HolidaysShow },
  { path: '/holidays/:id/edit', comp: HolidaysUpdate },

  // establishment permissions
  { path: '/establishment-permissions', comp: EstablishmentPermissionsList },
  { path: '/establishment-permissions/create', comp: EstablishmentPermissionsCreate },
  { path: '/establishment-permissions/:id', comp: EstablishmentPermissionsShow },
  { path: '/establishment-permissions/:id/edit', comp: EstablishmentPermissionsUpdate },

  // cards
  { path: '/pending-cards', comp: PendingCardsList },
  { path: '/pending-cards/:id', comp: PendingCardsShow },
  { path: '/all-cards', comp: AllCardsList },

  // permisisons
  { path: '/permissions', comp: Permissions },
  { path: '/permissions/create', comp: PermissionsCreate },
  { path: '/permissions/:id', comp: PermissionShow },
  { path: '/permissions/:id/edit', comp: PermissionUpdate },

  // tcard roles
  { path: '/tcard-roles', comp: TcardRoles },
  { path: '/tcard-roles/create', comp: TcardRolesCreate },
  { path: '/tcard-roles/:id', comp: TcardRolesShow },
  { path: '/tcard-roles/:id/edit', comp: TcardRolesUpdate },

  // private client lead funnel
  { path: '/private-clients', comp: PrivateClientsFunnelList },
  { path: '/private-clients/:id/edit', comp: PrivateClientsFunnelUpdate },
  { path: '/private-clients/:privateCompanyLeadId/contacts/:id/edit', comp: PrivateClientsFunnelContactsUpdate },
  { path: '/private-clients/:privateCompanyLeadId/contracts/:id/edit', comp: PrivateClientsFunnelContractsUpdate },

  // public client lead funnel
  { path: '/public-clients', comp: PublicCompanyFunnelList },
  { path: '/public-clients/:id/edit', comp: PublicCompanyFunnelUpdate },
  { path: '/public-clients/:publicCompanyLeadId/contacts/:id/edit', comp: PublicFunnelContactsUpdate },
  { path: '/public-clients/:publicCompanyLeadId/contracts/:id/edit', comp: PublicFunnelContractsUpdate },

  // establishment lead funnel
  { path: '/establishment-leads', comp: EstablishmentFunnelList },
  { path: '/establishment-leads/:id/edit', comp: EstablishmentFunnelUpdate },
  { path: '/establishment-leads/:establishmentLeadId/contacts/:id/edit', comp: EstablishmentFunnelContactsUpdate },
  { path: '/establishment-leads/:establishmentLeadId/contracts/:id/edit', comp: EstablishmentFunnelContractsUpdate },

  // tcard users
  { path: '/users', comp: UserIndex },
  { path: '/users/create', comp: UserCreate },
  { path: '/users/:id/edit', comp: UserUpdate },
  { path: '/users/:id/actionsHistory/:requestId', comp: UserActionsHistoryShow },
  { path: '/users/:id/*', comp: UserShow },

  // transactions (consumption, refund, card current limit)
  { path: '/consumption', comp: Consumption },
  { path: '/card-current-limit', comp: CardCurrentLimitsShow },
  { path: '/refund', comp: Refund },

  { path: '/users/me/actionsHistory/:requestId', comp: UserProfileActionsHistoryShow },
  { path: '/users/me/*', comp: UserProfileShow },

  // pos
  { path: '/pos', comp: PosList },
  { path: '/pos/qrcode/:id/*', comp: PosQrCode },
  { path: '/pos/:id', comp: PosShow },

  // external support
  { path: '/external-support', comp: ExternalSupportList },
  { path: '/external-support/create', comp: ExternalSupportCreate },
  { path: '/external-support/:id', comp: ExternalSupportShow },

  // internal support
  { path: '/internal-support', comp: InternalSupportList },
  { path: '/internal-support/create', comp: InternalSupportCreate },
  { path: '/internal-support/:id', comp: InternalSupportShow },
  { path: '/internal-support/:id/edit', comp: InternalSupportUpdate },

  // fiscal document
  { path: '/events-with-fiscal-document-requirement', comp: EventsWithFiscalDocumentRequirementList },
  { path: '/events-with-fiscal-document-requirement/:id', comp: EventsWithFiscalDocumentRequirementShow },
  { path: '/billing-fiscal-document-groups', comp: BillingFiscalDocumentGroupsList },
  { path: '/billing-fiscal-document-groups/:id', comp: BillingFiscalDocumentGroupsShow },

  // bills
  { path: '/client-bills/', comp: ClientBillsList },
  { path: '/client-bills/:billId/*', comp: ClientBillShow },
  { path: '/establishment-bills/', comp: EstablishmentBillsList },
  { path: '/establishment-bills/:billId/*', comp: EstablishmentBillShow },

  // reports
  { path: '/reports', comp: ReportsPermittedReports },
  { path: '/reports/create', comp: ReportsSubmit },

  // government allocation
  { path: '/government-allocation-entries/not-completed', comp: GovernmentAllocationsEntriesNotCompletedList },
  { path: '/supply-authorizations', comp: SupplyAuthorizationsList },
  { path: '/supply-authorizations/:id', comp: SupplyAuthorizationsShow },

  // bill payment advances
  { path: '/payment-advances', comp: PaymentAdvanceList },
  { path: '/payment-advances/:id', comp: PaymentAdvanceShow },
  { path: '/payment-advances/:billId/create', comp: PaymentAdvanceCreate },

  // negotiations
  { path: '/negotiations', comp: NegotiationsList },
  { path: '/negotiations/:id', comp: NegotiationsShow },

  // notifications
  { path: '/notifications/configurations', comp: NotificationsConfigurationsShow },
  
  // tmais reward items
  { path: '/tmais-reward-items', comp: RewardItems },
  { path: '/tmais-reward-items/create', comp: RewardItemsCreate },
  { path: '/tmais-reward-items/:id', comp: RewardItemsShow },
  { path: '/tmais-reward-items/:id/edit', comp: RewardItemsUpdate },
  
  // tmais badges
  { path: '/tmais-badges', comp: TmaisBadgesList },
  { path: '/tmais-badges/new', comp: TmaisBadgesCreate },
  { path: '/tmais-badges/:id', comp: TmaisBadgesShow },
  { path: '/tmais-badges/:id/edit', comp: TmaisBadgesUpdate },
  
  // tmais raffles
  { path: '/tmais-raffles', comp: TmaisRafflesList },
  { path: '/tmais-raffles/:id', comp: TmaisRafflesShow },
  { path: '/tmais-raffles/create', comp: TmaisRafflesCreate },
  { path: '/tmais-raffles/:id/edit', comp: TmaisRafflesUpdate },

  // tmais users
  { path: '/tmais-users', comp: TmaisUsers },
  { path: '/tmais-users/:id', comp: TmaisUsersShow },
  { path: '/tmais-users/:id/edit', comp: UsersUpdate },
  
  // tmais banners
  { path: '/tmais-banners', comp: TmaisBannersList },
  { path: '/tmais-banners/create', comp: TmaisBannersCreate },
  { path: '/tmais-banners/:id', comp: TmaisBannerShow },
  { path: '/tmais-banners/:id/edit', comp: TmaisBannerUpdate },

  // logs
  { path: '/logs', comp: LogList },
  { path: '/logs/:requestId', comp: LogShow },

  // establishment required documents
  { path: '/establishment-required-documents', comp: EstablishmentRequiredDocumentsList },
  { path: '/establishment-required-documents/create', comp: EstablishmentRequiredDocumentsCreate },
  { path: '/establishment-required-documents/:id', comp: EstablishmentRequiredDocumentsShow },
  { path: '/establishment-required-documents/:id/edit', comp: EstablishmentRequiredDocumentsUpdate },

  // establishment infrastructures
  { path: '/establishment-infrastructures', comp: EstablishmentInfrastructuresList },
  { path: '/establishment-infrastructures/create', comp: EstablishmentInfrastructuresCreate },
  { path: '/establishment-infrastructures/:id', comp: EstablishmentInfrastructuresShow },
  { path: '/establishment-infrastructures/:id/edit', comp: EstablishmentInfrastructuresUpdate },

  // establishment technical professionals
  { path: '/establishment-technical-professionals', comp: EstablishmentTechnicalProfessionalsList },
  { path: '/establishment-technical-professionals/create', comp: EstablishmentTechnicalProfessionalsCreate },
  { path: '/establishment-technical-professionals/:id', comp: EstablishmentTechnicalProfessionalsShow },
  { path: '/establishment-technical-professionals/:id/edit', comp: EstablishmentTechnicalProfessionalsUpdate },

  // objective maintenance
  { path: '/objective-maintenance/*', comp: MaintenanceObjectiveMaintenance },
  { path: '/objective-maintenance/systems/create', comp: MaintenanceObjectiveSystemsCreate },
  { path: '/objective-maintenance/systems/:id', comp: MaintenanceObjectiveSystemsShow },
  { path: '/objective-maintenance/systems/:id/edit', comp: MaintenanceObjectiveSystemsUpdate },
  { path: '/objective-maintenance/parts/create', comp: MaintenanceObjectivePartsCreate },
  { path: '/objective-maintenance/parts/:id', comp: MaintenanceObjectivePartsShow },
  { path: '/objective-maintenance/parts/:id/edit', comp: MaintenanceObjectivePartsUpdate },
  { path: '/objective-maintenance/actions/create', comp: MaintenanceObjectiveActionsCreate },
  { path: '/objective-maintenance/actions/:id', comp: MaintenanceObjectiveActionsShow },
  { path: '/objective-maintenance/actions/:id/edit', comp: MaintenanceObjectiveActionsUpdate },

  // ?
  { path: '/receivable-invoices', comp: Building },
  { path: '/payable-invoices', comp: Building },
  { path: '/archive', comp: Building },
  { path: '/operations', comp: Building },
  { path: '/invoices', comp: Building },
  { path: '/clients', comp: Building },
  { path: '/transactions', comp: Building },
];
